module.exports = __webpack_public_path__ + "static/browze-logo-445ba8856c9fb2ca5732ea402d7acca1.jpeg";